import { Component, OnInit } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CommonService } from './services/common.service';
import { LoaderService } from './services/loader.service';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers:[MessageService]
})
export class AppComponent {
  title = 'BoardRoom';
  isIframe = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private broadcastService: MsalBroadcastService,
    private authService: MsalService,
    private commonSvc: CommonService,
    public loaderService: LoaderService
  ) {


  }
  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.commonSvc.isLogin.next(this.authService.instance.getAllAccounts().length > 0)
        if (this.authService.instance.getAllAccounts().length > 0) {
          this.commonSvc.getUserDetails().subscribe((user: any) => {
            this.commonSvc.loggedInUser.next(user);
          })
        }
      })
  }
}
